import React, { useContext } from "react";
import { AppContext } from "./../AppContext";
import { formatNumer } from "../Web3/Function";

function Redeem() {
  const { totalSEth, tatalSBsc } = useContext(AppContext);

  return (
    <div className="m-t-2">
      <div className="row">
        <div className="col-12 col-sm-6  b-r_1">
          <div className="d-f a-i-c j-c-s-b m-q-m-b-2">
            <div className="f-w-600 t-a-l">Total RUSD Minted (BSC)</div>
            <div>{formatNumer(tatalSBsc)}</div>
          </div>
        </div>
        <div className="col-12 col-sm-6  b-r_1">
          <div className="d-f a-i-c j-c-s-b m-q-m-b-2">
            <div className="f-w-600 t-a-l">Total RUSD Minted (ETH)</div>
            <div>{formatNumer(totalSEth)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Redeem;
